import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { WizardStepIndex } from "../../shared/enums/WizardStep";
import { action } from "../../store/action";
import { useMachineTonnage } from "../../store/hooks/useMachineTonnage";
import MachineTonnageSwitch from "../MachineTonnage/MachineTonnageSwitch";
import DisclamerText from "../shared/DisclamerText";
import WizardContainer from "./Container/WizardContainer";
import "./MachineTonnageStep.scss";

const MachineTonnageStep = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation("machinetonnagestep");
  const machineTonnage = useMachineTonnage();

  const enableNext =
    machineTonnage && (machineTonnage.machineModel || machineTonnage.tonnage)
      ? true
      : false;

  useEffect(() => {
    dispatch(
      action.saveWizard({
        activeStepIndex: WizardStepIndex.MachineTonnage,
        enableNext,
      })
    );
  }, [dispatch, enableNext]);

  useEffect(() => {
    dispatch(action.saveIsLoadedFromSummary(false));
  }, [dispatch]);

  return (
    <WizardContainer>
      <div>
        <div className="desktopWidth">
          <h1>{t("machinetonnagetexts.machinetonnageheader")}</h1>
          <div>
            <p>{t("machinetonnagetexts.machinetonnageintro")}</p>
          </div>
        </div>
        <MachineTonnageSwitch machineTonnage={machineTonnage} />
      </div>
      <div>
        <DisclamerText />
      </div>
    </WizardContainer>
  );
};

export default MachineTonnageStep;
